import { createFileRoute, redirect } from "@tanstack/react-router";

import { PartnersPage } from "@/components/marketing/partners-page";
import { MARKETING_FLAGS } from "@/lib/marketing-flags";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/partners/")({
  beforeLoad: () => {
    if (!MARKETING_FLAGS.partners) {
      throw redirect({ to: "/" });
    }
  },
  head: () => pageHead("partners"),
  component: PartnersPage,
});
